import { Component } from "react";
import React from "react";
import AddOrderStatus from "../common/AddOrderStatus"
import {Loading,LoadingDone,Reset,Success,Error,GetStatus} from "../../actions/loading"
import PageSpinner from "../PageSpinner";
import Banner from "../common/banner";
import StatusGrid from '../../components/common/orderproductstatusgrid'
import axios from 'axios';
import appConfig from '../../config/config';

import { connect } from "react-redux";
import {
    Button
} from 'reactstrap';


const colHeader = [
    { dataField: 'ID', text: 'Sr No' },
    { dataField: 'NAME', text: 'Status' },
    { dataField: 'CREATEDDATE', text: 'Date' }
];
var dataColumns = colHeader.map(function (d) { return { dataField: d.dataField, text: d.text, sort: true } });

class OrderStatusPage extends Component {
    constructor(...args) {
        super(...args);
        this.state = { Add:false }

    }
    loadStatus=()=> {
        this.props.Loading();
        axios.post(
            appConfig.apiGateway.searchOrderUrl,
            JSON.stringify({ OrderProductId: this.props.OrderProductId, Action: "OrderProductStatus" }),
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.props.session.session.credentials.accessToken}`
                }
            }
        ).then(response => {
            this.props.LoadingDone();
            this.props.GetStatus(JSON.parse(response.data.body));
        }, error => {
            this.props.LoadingDone();
        });
    }
    componentDidMount(){
        this.loadStatus();
    }
    Edit = ( row)=> {
        this.setState({ ...this.state, row:row });
    }
    render() {
        return (
           <>
                {this.props.loading.showBanner && (<Banner 
                            Close={this.props.Reset} 
                            message={this.props.loading.message} 
                            IsSuccess={this.props.loading.isSuccess}/>)}
                <div style={{textAlign:'right'}}>
                    <Button style={{marginTop:'5px', marginBottom:'5px'}} 
                            onClick={()=> this.setState({...this.state, Add:true})}>
                     Add</Button> 
                </div>
                {this.state.Add && <AddOrderStatus 
                    OrderProductId={this.props.OrderProductId}
                    Add={(s) => this.setState({...this.state, Add:s})}
                    Refresh={this.props.Refresh}
                    />}
                {(this.props.loading.loading == true) && (< PageSpinner />)}
                {(this.props.loading.loading == false) && (<StatusGrid 
                    data={this.props.status.data} 
                    OrderColumns={dataColumns} 
                    setSelectedRow={this.Edit}
                    />)}
           </>
        )}
}
var orderStatusPage = connect(
    state => ({
        session: state.session,
        loading : state.loading,
        status  : state.OrderProductStatus
    }),{LoadingDone,Loading,Success,Error,Reset,GetStatus}
)(OrderStatusPage);
export default orderStatusPage